import styles from './content.module.css'
import classnames from 'classnames'

interface ContentProps {
  className?: string,
  children: React.ReactNode,
  width?: 'default' | 'wide' | 'fullwidth',
  suppressPadding?: boolean,
}

const Content = ({ children, className = '', width = 'default', suppressPadding = false }: ContentProps) =>
  <div className={styles.contentWrapper}>
    <div className={classnames(styles.content, className, {
      [styles.contentWide]: width === 'wide',
      [styles.contentFullWidth]: width === 'fullwidth',
      [styles.suppressPadding]: suppressPadding,
    })}>
      { children }
    </div>
  </div>

export default Content
